import axios from "axios"
import { GetRoleInterface } from "@type/security.types"

const ROOT_PATH = "roles"
export default class RoleService {
	static createRole = (payload: any, userId: string) =>
		axios.post<{ data: GetRoleInterface[]; successMessage: string }>(`${ROOT_PATH}/${userId}`, payload)

	static getRoleByUserId = (userId: string) => axios.get<GetRoleInterface[]>(`${ROOT_PATH}/${userId}`)

	// TODO - DEPRECATED - Why it's being called in ABAC Layout
	static getAllRoles = () => axios.get<Array<GetRoleInterface>>(`${ROOT_PATH}`)

	// TODO - DEPRECATED
	static getRoleById = (id: string) => axios.get<GetRoleInterface>(`${ROOT_PATH}/${id}`)

	// TODO - DEPRECATED
	static updateRole = (id: string, notifiee: Partial<GetRoleInterface>) =>
		axios.put<GetRoleInterface>(`${ROOT_PATH}/${id}`, notifiee)

	// TODO - DEPRECATED - NEEDS TO BE CHANGED HERE - STRUCTURED CHANGED
	static getUserRoleByOrganization = () => axios.get(`${ROOT_PATH}/allowed-resources`)

	// TODO - DEPRECATED
	static updateUserRoles = (payload: { id: string; roles: GetRoleInterface[] }) =>
		axios.put<GetRoleInterface>(`${ROOT_PATH}/user-roles`, payload)
}
